import React, {useEffect, useRef} from "react";
import {Card, Form, UncontrolledTooltip} from "reactstrap";
import {IoMdCloseCircleOutline} from "react-icons/io";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import Button from "../../../components/Button";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {
  requestTestSensors,
  storeCreateTestData,
  storeTestTemplateList,
  setTestFormVisibility,
} from "../../../redux/Actions/reports.actions";
import {
  getCreateTemplateData,
  getTestSensorsList,
  getCreateTestData,
  getTestTemplateList,
} from "../../../redux/Selectors/reports.selectors";

const TestForm = () => {
  const dispatch = useDispatch();
  const sensorRef = useRef();
  const testSensorsList = useSelector(getTestSensorsList);
  const testTemplateList = useSelector(getTestTemplateList);
  const createTestData = useSelector(getCreateTestData);
  const {label = "", value = "", id = ""} = createTestData;
  const createTemplateData = useSelector(getCreateTemplateData);
  const {inventory = ""} = createTemplateData;

  const onChangeHandler = (e) => {
    let updateObj = {...createTestData};
    updateObj = Object.assign({}, updateObj, {
      label: e.target.label,
      value: e.target.value,
    });
    dispatch(storeCreateTestData(updateObj));
  };

  useEffect(() => {
    if (inventory) {
      if (id) {
        if (testTemplateList?.length === 0) {
          dispatch(storeCreateTestData({}));
          dispatch(setTestFormVisibility(false));
        }
      } else {
        onChangeHandler({target: {}});
        sensorRef?.current?.clearValue();
      }
      dispatch(requestTestSensors(inventory));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventory, testTemplateList]);

  const addTestTemplate = () => {
    if (value) {
      let tempList = [...testTemplateList];
      let index = -1;
      if (tempList?.length > 0) {
        index = tempList.findIndex((template) => template.value === value);
      }
      if (index === -1) {
        let updateObj = {label, value};
        if (id) {
          tempList[id - 1] = updateObj;
        } else {
          tempList?.push(updateObj);
        }
        dispatch(storeTestTemplateList(tempList));
        dispatch(storeCreateTestData({}));
        dispatch(setTestFormVisibility(false));
      } else {
        toast.error(`${label} result is already added`);
      }
    } else {
      toast.error("Please check required fields");
    }
  };

  const closeTestForm = () => {
    dispatch(storeCreateTestData({}));
    dispatch(setTestFormVisibility(false));
  };

  return (
    <Card
      style={{
        padding: "1rem 0px",
        boxShadow: "0px 3px 6px #00000029",
        position: "relative",
      }}
    >
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 1rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        Add Result
      </div>
      <span
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          fontSize: "20px",
          cursor: "pointer",
        }}
      >
        <IoMdCloseCircleOutline id="test-form-close-button" onClick={closeTestForm} />
      </span>
      {document.getElementById("test-form-close-button") && (
        <span>
          <UncontrolledTooltip target="test-form-close-button" placement={"top"}>
            Close
          </UncontrolledTooltip>
        </span>
      )}
      <Form>
        <SelectCreator
          inSingleRow
          label={"Sensor"}
          isRequired
          ref={sensorRef}
          closeMenuOnSelect={true}
          options={testSensorsList}
          onChange={onChangeHandler}
          name={"sensor"}
          value={value}
          colSize={12}
          placeholder={"Select Sensor"}
          classNamePrefix={"selectResult"}
          id={"selectResult"}
        />
        <div className="d-flex justify-content-end" style={{marginRight: "1rem"}}>
          <Button withRadius onClick={addTestTemplate} data-cy="createResult">
            {id ? "SAVE" : "ADD"}
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default TestForm;
